import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/blank-logo.png';
const _withScopeId = n => (_pushScopeId("data-v-05984bf6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-left-banner"
}, null, -1));
const _hoisted_3 = {
  class: "library-top-text1"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-title-span"
}, "企业", -1));
const _hoisted_5 = {
  class: "library-top-text2"
};
const _hoisted_6 = {
  class: "library-top-text1"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-title-span"
}, "个人", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-top-text2"
}, " 欢迎使用腾讯电脑管家软件开放平台 ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-left-banner"
}, null, -1));
const _hoisted_10 = {
  class: "library-center"
};
const _hoisted_11 = {
  key: 0,
  class: "library-message"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 身份认证及软件审核预计3-5个工作日返回结果，在此期间您可优先创建应用 ", -1));
const _hoisted_13 = {
  key: 1,
  class: "library-message1"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 开发者身份认证被驳回，可点击查看驳回理由。请修改后重新提交审核。 ", -1));
const _hoisted_15 = {
  class: "library-card"
};
const _hoisted_16 = {
  class: "library-title"
};
const _hoisted_17 = {
  class: "library-box"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(['library-box__text', 'library-box__active'])
}, " 我的软件库 ", -1));
const _hoisted_19 = {
  class: "library-nobody",
  key: "1"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card-icon",
  src: _imports_0,
  style: {
    "width": "230px",
    "height": "225px",
    "margin-top": "60px"
  }
}, null, -1));
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  class: "library-body",
  key: "2",
  style: {
    "height": "350px"
  }
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  class: "library-body",
  key: "2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_icon = _resolveComponent("t-icon");
  const _component_t_link = _resolveComponent("t-link");
  const _component_t_dialog = _resolveComponent("t-dialog");
  const _component_t_button = _resolveComponent("t-button");
  const _component_SoftwareCard = _resolveComponent("SoftwareCard");
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar");
  const _component_t_content = _resolveComponent("t-content");
  const _component_Footer = _resolveComponent("Footer");
  const _component_t_layout = _resolveComponent("t-layout");
  return _openBlock(), _createBlock(_component_t_layout, {
    style: 'height: 100%'
  }, {
    default: _withCtx(() => [_createVNode(_component_t_content, null, {
      default: _withCtx(() => [_createElementVNode("div", {
        style: _normalizeStyle({
          height: _ctx.user.confirmed == 2 ? '920px' : '990px',
          backgroundColor: '#F6FAFF'
        })
      }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _ctx.user.identityType == 2 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({
          background: 'url(' + _ctx.companybg + ')'
        }),
        class: "library-top"
      }, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.user.userName) + " ", 1), _hoisted_4]), _createElementVNode("div", _hoisted_5, "当前管理者 " + _toDisplayString(_ctx.user.vagueName), 1)], 4)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: _normalizeStyle({
          background: 'url(' + _ctx.personbg + ')'
        }),
        class: "library-top"
      }, [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.user.vagueName) + " ", 1), _hoisted_7]), _hoisted_8], 4)), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_ctx.user.confirmed == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_t_icon, {
        class: "message-icon",
        name: "chevron-down-circle"
      }), _hoisted_12])) : _createCommentVNode("", true), _ctx.user.confirmed == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_t_icon, {
        name: "error-circle",
        class: "message-icon1",
        style: {
          "color": "#f24014"
        }
      }), _hoisted_14, _createVNode(_component_t_link, {
        style: _normalizeStyle(['color: #0029ff;', {
          "font-size": "18px",
          "padding-left": "325px"
        }]),
        hover: "color",
        onClick: _ctx.refuseReason
      }, {
        default: _withCtx(() => [_createTextVNode("查看理由 ")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_t_dialog, {
        visible: _ctx.refuseVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => _ctx.refuseVisible = $event),
        header: "驳回理由",
        "confirm-on-enter": false,
        "close-btn": true,
        body: _ctx.comments,
        "on-confirm": _ctx.onConfirm,
        "confirm-btn": {
          content: '去修改',
          theme: 'primary'
        },
        cancelBtn: null
      }, null, 8, ["visible", "body", "on-confirm"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _ctx.user.isCommercial ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "library-box__text",
        onClick: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _ctx.goToAdLibrary && _ctx.goToAdLibrary(...args))
      }, " 商包广告库 ")) : _createCommentVNode("", true)]), _ctx.listFlag ? (_openBlock(), _createBlock(_component_t_button, {
        key: 0,
        variant: "outline",
        theme: "primary",
        style: {
          "width": "150px"
        },
        onClick: _ctx.log_add
      }, {
        default: _withCtx(() => [_createTextVNode(" + 新增软件 ")]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]), !_ctx.listFlag ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createVNode(_component_t_button, {
        variant: "outline",
        theme: "primary",
        style: {
          "margin-top": "30px",
          "width": "150px"
        },
        onClick: _ctx.log_add
      }, {
        default: _withCtx(() => [_createTextVNode(" + 新增软件 ")]),
        _: 1
      }, 8, ["onClick"])])) : _ctx.listFlag ? (_openBlock(), _createBlock(_component_perfect_scrollbar, {
        key: 1
      }, {
        default: _withCtx(() => [[4, 5, 6].indexOf(_ctx.softwareList.length) >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareList, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createVNode(_component_SoftwareCard, {
            class: "software-card-body",
            infos: "",
            softtwareData: item
          }, null, 8, ["softtwareData"])]);
        }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareList, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createVNode(_component_SoftwareCard, {
            class: "software-card-body",
            infos: "",
            softtwareData: item
          }, null, 8, ["softtwareData"])]);
        }), 128))])]))]),
        _: 1
      })) : _createCommentVNode("", true)])])], 4)]),
      _: 1
    }), _createVNode(_component_Footer)]),
    _: 1
  });
}